<template>
  <div v-if="currentArticle">
    <BreadCrumd :title="'Articles'" :description="'Aperçu d\'un article'" />

    <div class="row">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router.push({ name: 'gpao_article' }).catch(() => {})
          "
        >
          Liste des articles
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'gpao_article-create' }).catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvel article
        </button>

        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'gpao_article-edit',
                params: { id: currentArticle.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-3">
          <div class="card mb-n1">
            <div class="card-body mb-n2">
              <div class="row">
                <div class="col-12">
                  <div
                    class="d-flex flex-column align-items-center justify-content-center text-center"
                  >
                    <img
                      v-if="currentArticle.url_image"
                      class="rounded-circle"
                      alt="Image"
                      width="200"
                      height="200"
                      :src="currentArticle.url_image"
                      data-holder-rendered="true"
                    />
                    <img
                      v-else
                      class="rounded-circle"
                      alt="Image"
                      width="200"
                      height="200"
                      :src="URL_LOCAL_FILE + '/images/no-image.png'"
                      data-holder-rendered="true"
                    />
                    <div class="mt-3">
                      <div>
                        <input
                          ref="imageUpload"
                          type="file"
                          style="display: none"
                          accept="image/*"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-9">
          <div class="card">
            <div class="row">
              <div class="col-12">
                <table class="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Type d'article :
                            </span>
                          </div>
                          <div>
                            {{
                              currentArticle.type === 'produits'
                                ? 'Produits'
                                : 'Service'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Référence : </span>
                          </div>
                          <div>
                            {{ currentArticle.reference }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Désignation :
                            </span>
                          </div>
                          <div>
                            {{ currentArticle.designation }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Pays de provenance / fabrication :
                            </span>
                          </div>
                          <div>
                            {{ currentArticle.pays }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Famille de l'article :
                            </span>
                          </div>
                          <div>
                            {{ currentArticle.famille.nom }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Unité de l'article :
                            </span>
                          </div>
                          <div>
                            {{
                              currentArticle.unite.code +
                              ' (' +
                              currentArticle.unite.nom +
                              ')'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Coût de revient :
                            </span>
                          </div>
                          <div>
                            {{ currentArticle.cout_revient | currency }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Prix de vente :
                            </span>
                          </div>
                          <div>
                            {{ currentArticle.prix_vente | currency }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Prix de vente min :
                            </span>
                          </div>
                          <div>
                            {{ currentArticle.prix_vente_min | currency }}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Quantité min :
                            </span>
                          </div>
                          <div>
                            {{
                              currentArticle.quantite_min +
                              ' ' +
                              currentArticle.unite.code
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              TVA général :
                            </span>
                          </div>
                          <div>
                            {{ currentArticle.tva | currency }}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Ligne budgétaire :
                            </span>
                          </div>
                          <div>
                            {{ currentArticle.ligne_budgetaire.nom }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Compte comptable achat :
                            </span>
                          </div>
                          <div>
                            {{ currentArticle.compte_comptable_achat }}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Compte comptable vente :
                            </span>
                          </div>
                          <div>
                            {{ currentArticle.compte_comptable_vente }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Compte comptable stock :
                            </span>
                          </div>
                          <div>
                            {{ currentArticle.compte_comptable_stock }}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Disponible pour achat ?
                            </span>
                          </div>
                          <div>
                            <b-badge
                              variant="custom-primary"
                              pill
                              v-if="currentArticle.achat"
                              class="p-2"
                            >
                              Oui
                            </b-badge>
                            <b-badge variant="danger" pill v-else class="p-2">
                              Non
                            </b-badge>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Disponible pour vente ?
                            </span>
                          </div>
                          <div>
                            <b-badge
                              variant="custom-primary"
                              pill
                              v-if="currentArticle.vente"
                              class="p-2"
                            >
                              Oui
                            </b-badge>
                            <b-badge variant="danger" pill v-else class="p-2">
                              Non
                            </b-badge>
                          </div>
                        </div>
                      </td>
                      <td v-if="currentArticle.type === 'produits'">
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Gestion par lot ?
                            </span>
                          </div>
                          <div>
                            <b-badge
                              variant="custom-primary"
                              pill
                              v-if="currentArticle.lot"
                              class="p-2"
                            >
                              Oui
                            </b-badge>
                            <b-badge variant="danger" pill v-else class="p-2">
                              Non
                            </b-badge>
                          </div>
                        </div>
                      </td>
                      <td v-else>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="far fa-user text-custom-primary"></i>
                            <span class="font-weight-bold"> Auteur </span>
                          </div>
                          <div class="text-primary">
                            <span v-if="currentArticle.created_by">
                              {{
                                currentArticle.created_by.prenom
                                  ? currentArticle.created_by.prenom +
                                    ' ' +
                                    currentArticle.created_by.nom
                                  : currentArticle.created_by.nom
                              }}
                            </span>
                            <span v-else>###</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="currentArticle.type === 'produits'">
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="far fa-user text-custom-primary"></i>
                            <span class="font-weight-bold"> Auteur </span>
                          </div>
                          <div class="text-primary">
                            <span v-if="currentArticle.created_by">
                              {{
                                currentArticle.created_by.prenom
                                  ? currentArticle.created_by.prenom +
                                    ' ' +
                                    currentArticle.created_by.nom
                                  : currentArticle.created_by.nom
                              }}
                            </span>
                            <span v-else>###</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card" v-if="currentArticle.type === 'produits'">
            <div class="row">
              <div class="col-12">
                <table class="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Entrepôt par défaut :
                            </span>
                          </div>
                          <div>
                            {{ currentArticle.resource.entrepot.nom }}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Stock de sécurité
                            </span>
                          </div>
                          <div>
                            {{
                              currentArticle.resource.stock_securite +
                              ' ' +
                              currentArticle.unite.code
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="row">
              <div class="col-12">
                <table class="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Description :
                            </span>
                          </div>
                          <div v-html="currentArticle.description"></div>
                        </div>
                      </td>

                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Commentaire </span>
                          </div>
                          <div v-html="currentArticle.commentaire"></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/article_stock/article';
import config from '@/config';
export default {
  data() {
    return {
      currentArticle: null,
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
      title: 'Gestion des articles - Aperçu',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    init() {
      window.axios
        .get(URL.ARTICLE + '/' + this.$route.params.id)
        .then((resp) => {
          this.currentArticle = resp.data.article;
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
